var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "imask", "../services/toastNotification"], function (require, exports, imask_1, toastNotification_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    imask_1 = __importDefault(imask_1);
    function padStart(value, size, padChar) {
        var s = value + "";
        while (s.length < size)
            s = padChar + s;
        return s;
    }
    function padToTwoDigits(num) {
        return padStart(num.toString(), 2, '0');
    }
    var defaultToastMs = 5000;
    var datetimeHelper = {
        formatDateTime: function (date, isUtc) {
            return ([
                padToTwoDigits(date.getDate()),
                padToTwoDigits(date.getMonth() + 1),
                date.getFullYear()
            ].join('/') +
                ' ' +
                [
                    padToTwoDigits((isUtc ? date.getHours() - 3 : date.getHours())),
                    padToTwoDigits(date.getMinutes()),
                    padToTwoDigits(date.getSeconds()),
                ].join(':'));
        },
        isRangeValid: function (startDate, endDate) {
            var splittedStart = startDate.value.split("/");
            var splittedEnd = endDate.value.split("/");
            if (splittedStart[0].length < 2 || splittedEnd[0].length < 2) {
                toastNotification_1.ToastNotification.Error("Dia inválido.", defaultToastMs);
                return false;
            }
            if (splittedStart[1].length < 2 || splittedEnd[1].length < 2) {
                toastNotification_1.ToastNotification.Error("Mês inválido.", defaultToastMs);
                return false;
            }
            if (splittedStart[2].length < 4 || splittedEnd[2].length < 4) {
                toastNotification_1.ToastNotification.Error("Ano inválido.", defaultToastMs);
                return false;
            }
            var from = new Date(parseInt(splittedStart[2]), parseInt(splittedStart[1]) - 1, parseInt(splittedStart[0]));
            var to = new Date(parseInt(splittedEnd[2]), parseInt(splittedEnd[1]) - 1, parseInt(splittedEnd[0]));
            if (from > to) {
                toastNotification_1.ToastNotification.Error("Data inicial maior que a final.", defaultToastMs);
                return false;
            }
            return true;
        },
        getCurrentDate: function () {
            var date = new Date();
            return datetimeHelper.getDateOnlyAsString(date);
        },
        getDateFromString: function (dateTime) {
            var date = new Date(dateTime);
            return datetimeHelper.getDateOnlyAsString(date);
        },
        getDateOnlyAsString: function (date) {
            var day = date.getDate().toString();
            var month = (date.getMonth() + 1).toString();
            var year = date.getFullYear();
            if (Number(day) < 10)
                day = "0" + day;
            if (Number(month) < 10)
                month = "0" + month;
            return day + "/" + month + "/" + year;
            ;
        },
        getBackendFormatDate: function (date) {
            var formatedDate = date.split('/');
            return [
                formatedDate[2],
                formatedDate[1],
                formatedDate[0]
            ].join('-');
        },
        maskDateFields: function (dateField) { return imask_1.default(dateField, {
            mask: Date,
            pattern: 'd/`m/`Y',
            blocks: {
                d: {
                    mask: imask_1.default.MaskedRange,
                    from: 1,
                    to: 31,
                    maxLength: 2,
                },
                m: {
                    mask: imask_1.default.MaskedRange,
                    from: 1,
                    to: 12,
                    maxLength: 2,
                },
                Y: {
                    mask: imask_1.default.MaskedRange,
                    from: 1900,
                    to: new Date().getFullYear(),
                    maxLength: 4,
                }
            },
            format: function (date) {
                var day = date.getDate().toString();
                var month = (date.getMonth() + 1).toString();
                var year = date.getFullYear().toString();
                if (Number(day) < 10)
                    day = "0" + day;
                if (Number(month) < 10)
                    month = "0" + month;
                return [day, month, year].join('/');
            },
            parse: function (str) {
                var dayMonthYear = str.split('/');
                return new Date(Number(dayMonthYear[2]), Number(dayMonthYear[1]) - 1, Number(dayMonthYear[0]));
            },
            lazy: true,
            min: new Date(1900, 0, 1),
            max: (function () {
                var now = new Date();
                return new Date(now.getFullYear(), now.getMonth(), now.getDate());
            })()
        }); },
        maskDateTimeFields: function (dateField) { return imask_1.default(dateField, {
            mask: Date,
            pattern: 'd/`m/`Y HH:mm',
            blocks: {
                d: {
                    mask: imask_1.default.MaskedRange,
                    from: 1,
                    to: 31,
                    maxLength: 2,
                },
                m: {
                    mask: imask_1.default.MaskedRange,
                    from: 1,
                    to: 12,
                    maxLength: 2,
                },
                Y: {
                    mask: imask_1.default.MaskedRange,
                    from: 1900,
                    to: new Date().getFullYear(),
                    maxLength: 4,
                },
                HH: {
                    mask: imask_1.default.MaskedRange,
                    from: 0,
                    to: 23
                },
                mm: {
                    mask: imask_1.default.MaskedRange,
                    from: 0,
                    to: 59
                }
            },
            format: function (date) {
                var day = date.getDate().toString();
                var month = (date.getMonth() + 1).toString();
                var year = date.getFullYear().toString();
                if (Number(day) < 10)
                    day = "0" + day;
                if (Number(month) < 10)
                    month = "0" + month;
                return [day, month, year].join('/');
            },
            parse: function (str) {
                var dayMonthYear = str.split('/');
                return new Date(Number(dayMonthYear[2]), Number(dayMonthYear[1]) - 1, Number(dayMonthYear[0]));
            },
            lazy: true,
            min: new Date(1900, 0, 1),
            max: (function () {
                var now = new Date();
                return new Date(now.getFullYear(), now.getMonth(), now.getDate());
            })()
        }); }
    };
    exports.default = datetimeHelper;
});
